import React, { useState, useEffect } from 'react';

import AdminPanGeneration from '../program/PanGeneration';

export default function PanGeneration() {

	return (
		<>
		<AdminPanGeneration admin={true}/>
		</>
	)

}
